// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2vCea","left":"styles_left__2BUd4"};